const OFFICE_INFORMATION_KEY = 'officeInformation';

export default OFFICE_INFORMATION_KEY;
